// Wrapper seguro para sessionStorage/localStorage.
//
// Em alguns navegadores mobile o acesso a Web Storage lança exceção e, se não
// for tratado, derruba o React antes de montar (tela branca total). Casos comuns:
//  - Safari/iOS em navegação privada (versões antigas)
//  - Webviews embutidas de apps (Instagram, Facebook, etc.)
//  - Configurações que bloqueiam cookies/armazenamento de terceiros
//
// Estas funções nunca lançam: em caso de falha, degradam para um valor neutro.

function getStore(kind) {
    try {
        return kind === "local" ? window.localStorage : window.sessionStorage;
    } catch {
        return null;
    }
}

export function safeGet(key, { kind = "session" } = {}) {
    try {
        const store = getStore(kind);
        return store ? store.getItem(key) : null;
    } catch {
        return null;
    }
}

export function safeSet(key, value, { kind = "session" } = {}) {
    try {
        const store = getStore(kind);
        if (store) store.setItem(key, value);
        return true;
    } catch {
        return false;
    }
}

export function safeRemove(key, { kind = "session" } = {}) {
    try {
        const store = getStore(kind);
        if (store) store.removeItem(key);
        return true;
    } catch {
        return false;
    }
}
